import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from './store';

export interface Merchant {
  merchantId: number;
  name: string;
}

interface InitState {
  list: Merchant[];
}

const initialState: InitState = { list: [] };

export const merchantListSlice = createSlice({
  name: 'merchantSlice',
  initialState,
  reducers: {
    setMerchantList: (state, action: PayloadAction<Merchant[]>) => {
      state.list = action.payload;
    },
  },
});

export const { setMerchantList } = merchantListSlice.actions;

export const selectMerchantList = (state: RootState) => state.merchantList;
export default merchantListSlice.reducer;
